import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-403d7722"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "submit-detail-page"
};
const _hoisted_2 = {
  class: "header-right"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 规则 ");
const _hoisted_4 = {
  key: 1,
  style: {
    "height": "15px"
  }
};
const _hoisted_5 = {
  class: "main-content"
};
const _hoisted_6 = {
  key: 0,
  class: "prize-image-container"
};
const _hoisted_7 = {
  class: "status-section"
};
const _hoisted_8 = {
  key: 0,
  class: "status-ongoing"
};
const _hoisted_9 = {
  key: 0,
  class: "status-text"
};
const _hoisted_10 = {
  key: 1,
  class: "status-text"
};
const _hoisted_11 = {
  key: 1,
  class: "status-drawing"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "status-text"
}, "已结束，开奖中", -1));
const _hoisted_13 = {
  class: "lottie-group"
};
const _hoisted_14 = {
  key: 2,
  class: "status-win"
};
const _hoisted_15 = {
  class: "win-left"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "win-text"
}, "恭喜！你已中奖！", -1));
const _hoisted_17 = {
  class: "lottie-group"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看奖品", -1));
const _hoisted_19 = {
  key: 3,
  class: "status-cancel"
};
const _hoisted_20 = {
  class: "status-text"
};
const _hoisted_21 = {
  class: "prize-card"
};
const _hoisted_22 = {
  class: "price-section"
};
const _hoisted_23 = {
  class: "price-info"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "currency"
}, "¥", -1));
const _hoisted_25 = {
  class: "price"
};
const _hoisted_26 = {
  key: 0,
  class: "original-price"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "divider"
}, "|", -1));
const _hoisted_28 = {
  class: "limit-text"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看项目", -1));
const _hoisted_30 = {
  key: 0,
  class: "base-info"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base-title"
}, "底座", -1));
const _hoisted_32 = {
  class: "base-project"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider-line"
}, null, -1));
const _hoisted_34 = {
  class: "lottery-code-section"
};
const _hoisted_35 = {
  class: "section-header"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-left"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "我的抽奖码"), /*#__PURE__*/_createElementVNode("span", {
  class: "subtitle"
}, "抽奖码越多中奖率越大")], -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1));
const _hoisted_38 = {
  key: 1,
  class: "lottery-rounds"
};
const _hoisted_39 = {
  class: "rounds-title"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-text"
}, "抽奖", -1));
const _hoisted_41 = {
  class: "title-text"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-divider"
}, null, -1));
const _hoisted_43 = {
  class: "rounds-list"
};
const _hoisted_44 = {
  class: "round-content"
};
const _hoisted_45 = {
  class: "round-header"
};
const _hoisted_46 = {
  class: "round-label"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "status-divider"
}, "|", -1));
const _hoisted_48 = {
  class: "round-time"
};
const _hoisted_49 = {
  class: "task-section"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "task-info"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "task-name"
}, "200积分兑换"), /*#__PURE__*/_createElementVNode("span", {
  class: "task-reward"
}, "抽奖码+1")], -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "task-btn"
}, "去兑换", -1));
const _hoisted_52 = [_hoisted_50, _hoisted_51];
const _hoisted_53 = {
  class: "task-info-wrapper"
};
const _hoisted_54 = {
  class: "task-info"
};
const _hoisted_55 = {
  class: "task-name"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "task-reward"
}, "抽奖码+1", -1));
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "task-desc"
}, "最多邀请10位好友", -1));
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "task-btn"
}, "去邀请", -1));
const _hoisted_59 = {
  class: "stats-text"
};
const _hoisted_60 = {
  class: "participant-avatars"
};
const _hoisted_61 = {
  key: 2,
  class: "notice-box"
};
const _hoisted_62 = {
  class: "notice-text"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "safe-area-spacer"
}, null, -1));
import { env } from "md-base-tools/env";
import domain from "@/service/domain";
import router from '@/router';
import { onMounted, ref, computed } from "vue";
import { GoBack, mdToast } from "@/utils/tools";
import api from '@api';
import CompLottieAnimation from '@@/lottieAnimation.vue';
import { urlFormatToJump } from '../../service/router';
import { jumpToApp } from '../../utils/tools';

// 路由参数

export default {
  setup(__props) {
    const activity_id = router.currentRoute.value.query.activity_id;

    // 状态变量
    const isFix = ref(0);
    const loading = ref(false);
    const error = ref('');

    // 数据模型
    const activityInfo = ref({
      activity_info: {
        title: '',
        activity_id: 0,
        status: 0,
        // 0:进行中 1:开奖中 2:已开奖 3:活动已取消
        is_win_prize: 0,
        // 是否中奖 1:中奖 0:未中奖
        end_time_unix: 0,
        // 剩余秒数
        ticket_count: 0,
        ticket_list: [],
        join_number: 0,
        join_list: [],
        draw_step_list: [],
        draw_condition_tip: '',
        require_condition: '',
        require_condition_title: ''
      },
      prize_list: [],
      item_info: {
        title: '',
        jump_url: '',
        user_id: 0,
        item_type: 0,
        item_type_name: '',
        item_id: 0
      },
      condition_list: []
    });

    // 当前奖品（取第一个）
    const currentPrize = computed(() => {
      if (activityInfo.value.prize_list && activityInfo.value.prize_list.length > 0) {
        return activityInfo.value.prize_list[0];
      }
      return {
        img: '',
        prize_name: '',
        price: 0,
        mark_price: 0,
        stock: 1
      };
    });

    // 状态配置 - 使用 computed
    const statusConfig = computed(() => {
      const status = activityInfo.value.activity_info.status;
      const isWin = activityInfo.value.activity_info.is_win_prize === 1;
      switch (status) {
        case 0:
          // 进行中
          return {
            text: `开奖时间 ${activityInfo.value.activity_info.end_time || ''}`,
            lottieUrl: null,
            iconUrl: null
          };
        case 1:
          // 开奖中
          return {
            text: '已结束，开奖中',
            lottieUrl: 'https://p6.moimg.net/mdwxapp/cp_submit_wait.json',
            iconUrl: null
          };
        case 2:
          // 已开奖
          if (isWin) {
            return {
              text: '恭喜！你已中奖！',
              lottieUrl: 'https://p6.moimg.net/mdwxapp/cp_submit_win.json',
              iconUrl: null
            };
          } else {
            return {
              text: '抱歉，你未中奖',
              lottieUrl: null,
              iconUrl: 'https://p6.moimg.net/mdwxapp/cp_submit_cancel.png'
            };
          }
        case 3:
          // 活动已取消
          return {
            text: '活动已取消',
            lottieUrl: null,
            iconUrl: 'https://p6.moimg.net/mdwxapp/cp_submit_cancel.png'
          };
        case 4:
          // 众筹未成功，活动已取消
          return {
            text: '众筹未成功，活动已取消',
            lottieUrl: null,
            iconUrl: 'https://p6.moimg.net/mdwxapp/cp_submit_cancel.png'
          };
        default:
          return {
            text: '',
            lottieUrl: null,
            iconUrl: null
          };
      }
    });

    // 格式化时间戳为日期字符串
    const formatEndTime = timestamp => {
      if (!timestamp) return '';
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}/${month}/${day} ${hours}:${minutes}`;
    };

    // 获取活动详情
    const getActivityDetail = async () => {
      if (!activity_id) {
        error.value = '缺少活动ID参数';
        mdToast('缺少活动ID参数');
        return;
      }
      try {
        loading.value = true;
        error.value = '';
        const response = await api.getSubmitDetail({
          activity_id: activity_id
        });
        if (response && response.status === 0) {
          activityInfo.value = response.data || {};
          console.log(activityInfo.value);
        } else {
          error.value = (response === null || response === void 0 ? void 0 : response.message) || '获取活动详情失败';
          mdToast(error.value);
        }
      } catch (err) {
        error.value = '网络请求失败，请稍后重试';
        mdToast(error.value);
        console.error('获取活动详情失败:', err);
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => {
      document.title = '活动详情';
      getActivityDetail();
    });

    // 返回上一页
    function handleGoBack() {
      GoBack();
    }

    // 是否吸顶
    function handleStickyAction(is_fix) {
      isFix.value = is_fix ? 1 : 0;
    }

    // 规则说明
    function handleRule() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/prize/submit_rule`,
        webFun: () => {
          router.push({
            path: `/prize/submit_rule`
          });
        }
      });
    }

    // 1. 查看项目
    function handleViewProject() {
      var _activityInfo$value$i;
      const jumpUrl = (_activityInfo$value$i = activityInfo.value.item_info) === null || _activityInfo$value$i === void 0 ? void 0 : _activityInfo$value$i.jump_url;
      if (jumpUrl) {
        urlFormatToJump(jumpUrl);
      }
    }

    // 2. 统一处理任务/查看操作
    async function handleAction() {
      try {
        await jumpToApp({
          type: 'CPSubmitPrize',
          id: this.activity_id
        });
      } catch (error) {
        // jumpToApp 内部已经处理了错误提示
        console.error('跳转APP失败:', error);
      }
    }
    return (_ctx, _cache) => {
      var _activityInfo$value$a, _activityInfo$value$a2, _activityInfo$value$a3, _activityInfo$value$a4, _activityInfo$value$a5, _activityInfo$value$a6, _unref2, _unref3, _unref4, _activityInfo$value$i2, _activityInfo$value$a7, _activityInfo$value$a8, _activityInfo$value$a9, _activityInfo$value$a0, _activityInfo$value$a1, _activityInfo$value$a10, _activityInfo$value$a11, _activityInfo$value$a12, _activityInfo$value$a13;
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(env).isWeixin() ? (_openBlock(), _createBlock(_component_van_sticky, {
        key: 0,
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }, {
            'isFix': isFix.value
          }])
        }, [_createVNode(_component_van_image, {
          class: "back-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score/task_back_icon.png', 40),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleGoBack(), ["stop"]))
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: "rule-info",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleRule(), ["stop"]))
        }, [_createVNode(_component_van_image, {
          class: "icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score/task_rule_icon.png', 32)
        }, null, 8, ["src"]), _hoisted_3])])], 2)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createElementVNode("div", _hoisted_5, [_unref(currentPrize) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_van_image, {
        class: "prize-image",
        src: _ctx.$imgUrlFilter(_unref(currentPrize).img, 500),
        fit: "cover"
      }, null, 8, ["src"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [((_activityInfo$value$a = activityInfo.value.activity_info) === null || _activityInfo$value$a === void 0 ? void 0 : _activityInfo$value$a.status) === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [!_unref(env).isModianIos() && !_unref(env).isModianAndroid() ? (_openBlock(), _createElementBlock("span", _hoisted_9, "开奖时间 " + _toDisplayString((_activityInfo$value$a2 = activityInfo.value.activity_info) === null || _activityInfo$value$a2 === void 0 ? void 0 : _activityInfo$value$a2.end_time), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_10, "开奖时间 " + _toDisplayString(formatEndTime((_activityInfo$value$a3 = activityInfo.value.activity_info) === null || _activityInfo$value$a3 === void 0 ? void 0 : _activityInfo$value$a3.end_time_unix)), 1))])) : ((_activityInfo$value$a4 = activityInfo.value.activity_info) === null || _activityInfo$value$a4 === void 0 ? void 0 : _activityInfo$value$a4.status) === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createVNode(CompLottieAnimation, {
        class: "lottie-item",
        jsonUrl: "https://p6.moimg.net/mdwxapp/cp_submit_wait.json",
        loop: true
      }), _createVNode(CompLottieAnimation, {
        class: "lottie-item",
        jsonUrl: "https://p6.moimg.net/mdwxapp/cp_submit_wait.json",
        loop: true
      }), _createVNode(CompLottieAnimation, {
        class: "lottie-item",
        jsonUrl: "https://p6.moimg.net/mdwxapp/cp_submit_wait.json",
        loop: true
      })])])) : ((_activityInfo$value$a5 = activityInfo.value.activity_info) === null || _activityInfo$value$a5 === void 0 ? void 0 : _activityInfo$value$a5.status) === 2 && ((_activityInfo$value$a6 = activityInfo.value.activity_info) === null || _activityInfo$value$a6 === void 0 ? void 0 : _activityInfo$value$a6.is_win_prize) === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createVNode(CompLottieAnimation, {
        class: "lottie-item",
        jsonUrl: "https://p6.moimg.net/mdwxapp/cp_submit_win.json",
        loop: true
      }), _createVNode(CompLottieAnimation, {
        class: "lottie-item",
        jsonUrl: "https://p6.moimg.net/mdwxapp/cp_submit_win.json",
        loop: true
      })])]), _createElementVNode("div", {
        class: "view-prize",
        onClick: _cache[2] || (_cache[2] = $event => handleAction('view_prize'))
      }, [_hoisted_18, _createVNode(_component_van_icon, {
        name: "arrow",
        size: "14",
        color: "#00c4a1"
      })])])) : (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(_unref(statusConfig).text), 1), _createVNode(_component_van_image, {
        class: "cancel-icon",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/cp_submit_cancel.png', 96)
      }, null, 8, ["src"])]))]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", _hoisted_25, _toDisplayString(((_unref2 = _unref(currentPrize)) === null || _unref2 === void 0 ? void 0 : _unref2.price) || 0), 1), (_unref3 = _unref(currentPrize)) !== null && _unref3 !== void 0 && _unref3.mark_price ? (_openBlock(), _createElementBlock("span", _hoisted_26, "￥" + _toDisplayString(_unref(currentPrize).mark_price), 1)) : _createCommentVNode("", true), _hoisted_27, _createElementVNode("span", _hoisted_28, "限" + _toDisplayString(((_unref4 = _unref(currentPrize)) === null || _unref4 === void 0 ? void 0 : _unref4.stock) || 1) + "份", 1)]), _createElementVNode("div", {
        class: "view-project",
        onClick: handleViewProject
      }, [_hoisted_29, _createVNode(_component_van_icon, {
        name: "arrow",
        size: "14",
        color: "#7f7f7f"
      })])]), _unref(currentPrize) ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString(((_activityInfo$value$i2 = activityInfo.value.item_info) === null || _activityInfo$value$i2 === void 0 ? void 0 : _activityInfo$value$i2.title) || '众筹名称'), 1)])) : _createCommentVNode("", true), _hoisted_33]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", {
        class: "header-right",
        onClick: _cache[3] || (_cache[3] = $event => handleAction('view_more_codes'))
      }, [_hoisted_37, _createVNode(_component_van_icon, {
        name: "arrow",
        size: "14",
        color: "#7f7f7f"
      })])])]), (_activityInfo$value$a7 = activityInfo.value.activity_info) !== null && _activityInfo$value$a7 !== void 0 && _activityInfo$value$a7.draw_step_list && ((_activityInfo$value$a8 = activityInfo.value.activity_info) === null || _activityInfo$value$a8 === void 0 ? void 0 : _activityInfo$value$a8.draw_step_list.length) > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, "分" + _toDisplayString((_activityInfo$value$a9 = activityInfo.value.activity_info) === null || _activityInfo$value$a9 === void 0 ? void 0 : _activityInfo$value$a9.draw_step_list.length) + "轮", 1)]), _hoisted_42, _createElementVNode("div", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_activityInfo$value$a0 = activityInfo.value.activity_info) === null || _activityInfo$value$a0 === void 0 ? void 0 : _activityInfo$value$a0.draw_step_list, (round, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "round-item"
        }, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, "第" + _toDisplayString(['一', '二', '三', '四', '五'][index]) + "轮", 1), _hoisted_47, _createElementVNode("span", {
          class: _normalizeClass(["round-status", {
            'status-finished': round.status === '2',
            'status-ongoing': round.status === '1'
          }])
        }, _toDisplayString(round.status === '2' ? '已开奖' : round.status === '1' ? '进行中' : '未开始'), 3)]), _createElementVNode("div", _hoisted_48, _toDisplayString(round.draw_time), 1)])]);
      }), 128))])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", {
        class: "task-item",
        onClick: _cache[4] || (_cache[4] = $event => handleAction('exchange_points'))
      }, _hoisted_52), _createElementVNode("div", {
        class: "task-item invite-task",
        onClick: _cache[5] || (_cache[5] = $event => handleAction('invite_friends'))
      }, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, "邀请好友助力(" + _toDisplayString(activityInfo.value.assist_count || 0) + "/10)", 1), _hoisted_56]), _hoisted_57]), _hoisted_58]), ((_activityInfo$value$a1 = activityInfo.value.activity_info) === null || _activityInfo$value$a1 === void 0 ? void 0 : _activityInfo$value$a1.join_number) > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "participation-stats",
        onClick: _cache[6] || (_cache[6] = $event => handleAction('view_participants'))
      }, [_createElementVNode("div", _hoisted_59, [_createElementVNode("span", null, "已有" + _toDisplayString((_activityInfo$value$a10 = activityInfo.value.activity_info) === null || _activityInfo$value$a10 === void 0 ? void 0 : _activityInfo$value$a10.join_number) + "人参与，查看全部", 1), _createVNode(_component_van_icon, {
        name: "arrow",
        size: "12",
        color: "#7f7f7f"
      })]), _createElementVNode("div", _hoisted_60, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((((_activityInfo$value$a11 = activityInfo.value.activity_info) === null || _activityInfo$value$a11 === void 0 ? void 0 : _activityInfo$value$a11.join_list) || []).slice(0, 8), (user, idx) => {
        return _openBlock(), _createBlock(_component_van_image, {
          round: "",
          key: idx,
          class: "avatar",
          src: _ctx.$imgUrlFilter(user.icon || 'https://p6.moimg.net/mdwxapp/default_avatar.png', 52)
        }, null, 8, ["src"]);
      }), 128))])])) : _createCommentVNode("", true)]), (_activityInfo$value$a12 = activityInfo.value.activity_info) !== null && _activityInfo$value$a12 !== void 0 && _activityInfo$value$a12.draw_condition_tip ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createVNode(_component_van_icon, {
        name: "warning-o",
        size: "16",
        color: "#7f7f7f"
      }), _createElementVNode("span", _hoisted_62, _toDisplayString(((_activityInfo$value$a13 = activityInfo.value.activity_info) === null || _activityInfo$value$a13 === void 0 ? void 0 : _activityInfo$value$a13.draw_condition_tip) || '若众筹未成功，开奖结果无效。'), 1)])) : _createCommentVNode("", true)]), _hoisted_63]);
    };
  }
};